import {
  IconNameEnum,
  useModuleBEM,
  useTripsStyles,
} from "@b2bportal/core-themes";
import {
  CoreTripsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./styles.module.scss";
import { ActionButton } from "@/components";

export interface TripsCardComponentProps extends PlatformComponentProps {
  status?: JSX.Element;
  product: JSX.Element;
  title: string;
  onClick: () => void;
  showViewDetails?: boolean;
  showBookingId?: boolean;
  bookingId?: string;
}

const COMPONENT_KEY = CoreTripsComponent.TripsCard;

export const TripsCard = ({
  className,
  children,
  status,
  product,
  title,
  onClick,
  bookingId,
  showBookingId = true,
  showViewDetails = true,
}: TripsCardComponentProps) => {
  const styles = useTripsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const content = (
    <>
      <div className={cn("product")}>{product}</div>
      <div className={cn("title")}>{title}</div>
      {children ? <div className={cn("product-info")}>{children}</div> : null}
      {showBookingId && (
        <div className={cn("booking-id")}>
          <div className={cn("booking-id-title")}>
            {t("trips.tripCard.bookingId")}
          </div>
          <div className={cn("booking-id-value")}>{bookingId}</div>
        </div>
      )}
      {showViewDetails && (
        <div className={cn("action-container")}>
          {status}
          <ActionButton
            onClick={() => onClick()}
            className={cn("view-details")}
            message={t("trips.tripCard.viewDetails")}
          />
        </div>
      )}
    </>
  );

  if (showViewDetails) {
    return <div className={clsx(block, className)}>{content}</div>;
  }

  return (
    <button className={clsx(block, className)} onClick={onClick}>
      {content}
    </button>
  );
};
